// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Sk2J","left":"StickyBox_left__2CJ-0","right":"StickyBox_right__ipK5_"};